import SORT_ORDER from 'src/enums/sortOrder';
import useFetchReducer from 'src/hooks/useFetchReducer';
import { FetchState } from 'src/reducers/fetchReducer';
import { ColumnSorting } from '../AlertTable.config';
import { AlertItem, AlertList } from '../../../types/AlertConfiguration';
import { getAlerts } from '../../../api/alertConfiguration.api';

export type AlertListState = FetchState<AlertItem[]> & {
  total: number;
  page: number;
  offset: number;
  size: number;
};

type PropsUseAlertListFetch = {
  sorting: ColumnSorting;
  page: number;
  pageSize: number;
  segmentId: string;
  associated: boolean;
  alertName: string;
};

const initialState: AlertListState = {
  loading: false,
  error: false,
  data: null,
  total: 0,
  page: 1,
  offset: 1,
  size: 0,
};

const useAlertListFetch = ({
  sorting,
  page,
  pageSize,
  segmentId,
  associated,
  alertName,
}: PropsUseAlertListFetch): [AlertListState, () => void] => {
  const params: AlertList.Request = {
    size: pageSize,
    offset: page > 1 ? (page - 1) * pageSize + 1 : 1,
    sortingOrder: SORT_ORDER[sorting.order],
    sortingColumn: sorting.field,
    segmentId,
    associated,
    alertName,
  };

  //TODO fix dependencies
  const [{ loading, data, error }, refetch] = useFetchReducer(
    () => getAlerts(params),
    [sorting, page, pageSize, segmentId, associated, alertName]
  );
  const state: AlertListState = { ...initialState, loading, error };

  if (data === null) {
    return [state, refetch];
  }

  const { alertList, totalRecords } = data;

  return [
    {
      ...state,
      data: alertList,
      total: Number(totalRecords),
    },
    refetch,
  ];
};

export default useAlertListFetch;
